import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export interface DashboardCounts {
  pendingApprovals: number;
  leaveRequests: number;
  attendance: number;
  otherRequests: number;
  leaveStatus: any;
}

@Injectable({ providedIn: 'root' })
export class EmployeeDashboardService {

  private _counts = new BehaviorSubject<DashboardCounts>({
    pendingApprovals: 0,
    leaveRequests: 0,
    attendance: 0,
    otherRequests: 0,
    leaveStatus: '',
  });

  counts$ = this._counts.asObservable();

  /** Called by tabs */
  updateCounts(partial: Partial<DashboardCounts>) {
    this._counts.next({
      ...this._counts.value,
      ...partial
    });
  }
}
